import type { LoadshiftSiteStatsResultAjax } from './loadshift-site-stats.backend-model';
import type { LoadshiftSiteStats } from './loadshift-site-stats.model';

export function transformLoadshiftSiteStats(
  stats: LoadshiftSiteStatsResultAjax,
  authUid: string,
): LoadshiftSiteStats {
  return {
    id: authUid,
    totalFreightKmInLast24Hrs: stats.total_freight_km_in_last_24_hrs,
    totalActiveJobsValue: stats.total_active_jobs_value,
    totalJobsPostedCount: stats.total_jobs_posted_count,
    totalShippersCount: stats.total_shippers_count,
    totalCarriersCount: stats.total_carriers_count,
    totalFreightKmInLastYear: stats.total_freight_km_in_last_year,
    totalLoadsLastYear: stats.total_loads_in_last_year,
  };
}
